import React, { useState } from "react";
import Input from "../../components/common/input/Input";
import Button from "../../components/common/button/Button";
import Backbutton from "../../components/common/backbutton/Backbutton";
import { useForgotPasswordInstance } from "../../utils/userInstance/useForgotPasswordinstance";
import { useSelector } from "react-redux";

const Forgotpassword = () => {
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({
        email: "",
    });
    const {forgetPassword} = useForgotPasswordInstance({});
    const {isUsermanagementLoader} = useSelector(state => state.loader);
    const handleInputChange = (e, field) => {
        let { value } = e.target;
        
        if (field === "email") {
            setEmail(value);  
            setErrors({...errors, email : "" })
        }
    };

    const validateForm = () => {
        let formErrors = { email: "" };
        let isValid = true;

        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            formErrors.email = "Please enter a valid email address.";
            isValid = false;
        }
        setErrors(formErrors);  
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            console.log("Logging in with email:", email);
            forgetPassword({email: email});
        }
    };

    return (
        <div className="bg-grey-200 w-full h-full lg:w-2/4 flex flex-col justify-center items-center p-5" style={{margin:'auto'}}>
            <div className="w-full min-w-[200px] xs:max-w-[320px] sm:max-w-[420px]">
                <div>
                    <p className="text-2xl font-bold text-center lg:text-start">Forgot password</p>
                    <p className="text-sm font-medium mt-2 text-center lg:text-start text-gray-500">
                        No worries! Just enter the email you used to sign up, and we’ll help you reset your password in no time.
                    </p>
                </div>
                <div className="mt-5">
                    <Input
                        type="text"
                        placeholder="Enter your email"
                        required={true}
                        label="Email"
                        value={email}
                        onChange={(e) => handleInputChange(e, "email")} 
                        error={errors.email} 
                        fullWidth={true}
                    />
                </div>
                <div className="mt-8">
                    <Button
                        label={isUsermanagementLoader ?
                            <div className="flex justify-center">
                                <svg class="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div> : "Verify"}
                        varient="contained"
                        color="primary"
                        fullWidth={true}
                        onClick={handleSubmit} 
                        disabled={isUsermanagementLoader}
                    />
                </div>
                <Backbutton />
            </div>
        </div>
    );
};

export default Forgotpassword;
